<template>
	
	<div class="content-area__inner">
		
		<legend class="content-area__element-title">Manual Entry</legend>
		
		<CommentBox hint-text="What has the client done now?" style="margin-bottom: 20px;" @on-add="onAddHistoryItem"/>
		
		<legend class="content-area__element-title">Entries<el-tag type="info">{{ history.length }}</el-tag></legend>
		
		<el-table class="card card--border card--no-padding" v-loading="$store.getters.loading" empty-text="This client has no history." :data="history">
			<el-table-column prop="date" label="Date" width="200"></el-table-column>
			<el-table-column label="Description">
				<template slot-scope="scope">
					<div class="history__description" v-html="scope.row.description"></div>
				</template>
			</el-table-column>
			<el-table-column label="Project" width="200">
				<template slot-scope="scope">
					<router-link v-if="scope.row.project" :to="{ name: 'projects/project', params: { projectSlug: scope.row.project.slug }}">{{ scope.row.project.name }}</router-link>
					<p v-else>N/A</p>
				</template>
			</el-table-column>
			<el-table-column prop="user" label="User" width="200"></el-table-column>
		</el-table>
		
	</div>
	
</template>

<script>
	
	import CommentBox from "@/components/Comments/CommentBox";
	
	export default {
		
		props: {
			
			client_id: {
				default: 0,
				type: Number,
			}
			
		},
		
		components: { CommentBox },
		
		computed: {
			
			history() {
				return this.response.map((data, i) => {
					return {
						id: data.id,
						date: this.$options.filters.dateFormatted(data.created_at),
						description: data.description ? data.description : "N/A",
						project: data.project ? data.project : "N/A",
						user: data.user ? data.user.name : "System",
						data: data,
					};
				});
			}
			
		},
		
		methods: {
			
			onAddHistoryItem(description) {
				this.$store.commit("setLoading", { type: "start" });
				this.axios.post("history", {
					client_id: this.client_id,
					description: description,
				}).then((r) => {
					this.$store.commit("setLoading", { type: "finish", message: "This history item has been added." });
					this.refresh();
				}).catch(function(e) {
					this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while adding this history item." });
				});
			},
			
			refresh() {
				this.$store.commit("setLoading", { type: "start" });
				this.axios.get(`history/${this.client_id}`).then((r) => {
					this.$store.commit("setLoading", { type: "finish" });
					this.response = r.data;
				}).catch((e) => {
					this.$store.commit("setLoading", { type: "error" });
					this.response = [];
				});
			}
			
		},
		
		mounted() {
			this.refresh();
		},
		
		data() {
			return {
				response: [],
			}
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/History/List.vue